/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { useCallback, useMemo } from "react";
import { TViewComponent } from "../../../view/IView";
import { ConfigEditorEdit } from "./ConfigEditorEdit";
import { Layout } from "../../../ui/components/Layout/Layout";
import {
	ConfigEditorEditContent,
	ConfigEditorEditOutline,
	ConfigEditorEditOutlineToolbar,
	ConfigEditorEditToolbar
} from "./components";

export const ConfigEditorEditComponent: TViewComponent<ConfigEditorEdit> = ({ view }) => {
	const layoutState = useMemo(() => view.getLayout(), []);

	const renderComponent = useCallback(
		(componentName: string) => {
			switch (componentName) {
				case "outlineToolbar":
					return <ConfigEditorEditOutlineToolbar />;
				case "outlineContent":
					return <ConfigEditorEditOutline view={view} />;
				case "mainToolbar":
					return <ConfigEditorEditToolbar view={view} />;
				case "mainContent":
					return <ConfigEditorEditContent view={view} />;
				default:
					return <p>Error: Undefined panel {componentName}.</p>;
			}
		},
		[ view ]
	);

	return <Layout state={layoutState} renderComponent={renderComponent} />;
};
